
/**   
 * 文章api管理
 */

import base from "./base";
var baseUrl = process.env.API_BASE_URL || '/api'
const xhr = new base(baseUrl);

// 新闻列表
export const GetNewsList = (pars) => {
  return xhr({
    url: "/Home/GetNewsList",
    method: "get",
    params: pars,
  })
}

export const GetNews = (id) => {
  return xhr({
    url: "/Home/GetNews",
    method: "get",
    params: { id },
  })
}


// 职位列表
export const GetPositionList = (pars) => {
  return xhr({
    url: "/Home/GetPositionList",
    method: "get",
    params: pars,
  })
}

export const GetPosition = (id) => {
  return xhr({
    url: "/Home/GetPosition",
    method: "get",
    params: { id },
  })
}

// 分类 树
export const GetPositionCategory = () => {
  return xhr({
    url: "/Home/GetPositionCategory",
    method: "get",
  })
}




// WEBPACK FOOTER //
// ./src/api/api.js